import useSWRImmutable from 'swr/immutable';

import { CompanyProfile } from 'models';

import { PayloadSDK } from 'services/PayloadSDK';

const useInvitableCompanies = () => {
    const swr = useSWRImmutable('invitable-companies', async () => {
        const { docs } = await PayloadSDK.find({
            collection: 'manufacturers',
            where: {
                'editorSupport.enabled': {
                    equals: true,
                },
            },
            pagination: false,
        });

        return docs as unknown as CompanyProfile[];
    });

    return {
        ...swr,
        companies: swr.data || [],
    };
};

export { useInvitableCompanies };
